import {
  type GetSignedUrlFn,
  type GetSignedUrlFnParams,
  useUploadFileMutation,
} from "@/axios/mutations/use-upload-file.mutation";
import type { GetProfilePictureUploadUrlRequestContentType } from "@/spz-api/model";
import { getProfilePictureUploadUrl } from "@/spz-api/user/user";
import { HARD_LIMITS } from "@spz/config";

export const useUploadPictureUrlMutation = () => {
  const getSignedUrl: GetSignedUrlFn = async ({
    file,
    data,
  }: GetSignedUrlFnParams) => {
    const contentType =
      file.type as GetProfilePictureUploadUrlRequestContentType;

    const signedUrlResponse = await getProfilePictureUploadUrl({
      contentType,
      md5Hash: data.md5Hash,
      fileName: data.fileName,
      fileSize: file.size,
    });

    return {
      uploadUrl: signedUrlResponse.uploadUrl,
      id: signedUrlResponse.id,
    };
  };

  return useUploadFileMutation({
    maxFileSize: HARD_LIMITS.userProfile.avatarMaxSize,
    getSignedUrl,
  });
};
